<!--
 * @Description:
 * @LastEditTime: 2024-04-01 12:59:59
 * @LastEditors: wudi
 * @Author: 何俊峰
 * @Date: 2024-02-01 17:01:32
-->
<template>
  <div class="login-container">
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on"
      label-position="left">
      <div class="title-container">
        <h3 class="title">
          {{ title }}
        </h3>
        <!-- <lang-select class="set-language" /> -->
      </div>
      <el-form-item prop="username">
        <span class="svg-container">
          <svg-icon icon-class="user" />
        </span>
        <el-input v-model="loginForm.username" :placeholder="$t('login.username')" name="username" type="text"
          auto-complete="on" />
      </el-form-item>

      <el-form-item prop="password">
        <span class="svg-container">
          <svg-icon icon-class="password" />
        </span>
        <el-input v-model="loginForm.password" :type="passwordType" :placeholder="$t('login.password')" name="password"
          auto-complete="on" @keyup.enter.native="handleLogin" />
        <span class="show-pwd" @click="showPwd">
          <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
        </span>
      </el-form-item>

      <el-checkbox v-model="checked" style="margin-bottom: 20px;color: #cccccc;">{{ $t('login.password1') }}
      </el-checkbox>

      <el-button :loading="loading" type="primary" style="width:100%;margin-bottom:30px;"
        @click.native.prevent="handleLogin">
        {{ $t('login.logIn') }}
      </el-button>

    </el-form>
    <particles></particles>
  </div>
</template>

<script>
  import {
    validUsername
  } from '@/utils/validate'
  import Particles from '@/components/Particles/index'

  import config from '@/config/index'
  import Cookies from 'js-cookie'
  import CryptoJS from 'crypto-js';
  const key = CryptoJS.enc.Utf8.parse("1234123412ABCDEF"); //十六位十六进制数作为密钥
  const iv = CryptoJS.enc.Utf8.parse('ABCDEF1234123412'); //十六位十六进制数作为密钥偏移量
  export default {
    name: 'Login',
    components: {
      Particles
    },
    data() {
      const validateUsername = (rule, value, callback) => {
        if (!validUsername(value)) {
          callback(new Error(this.$t('login.name')))
        } else {
          callback()
        }
      }
      const validatePassword = (rule, value, callback) => {
        if (value.length < 6) {
          callback(new Error(this.$t('login.pass')))
        } else {
          callback()
        }
      }
      console.log(config)
      return {
        title: config.txt.title,
        loginForm: {
          username: '', // 13123456789
          password: '' // 123456
        },
        loginRules: {
          username: [{
              required: true,
              trigger: 'blur',
              message: '账号不能为空'
            }
            // { required: true, trigger: 'blur', validator: validateUsername },
          ],
          password: [{
              required: true,
              trigger: 'blur',
              message: '密码不能为空'
            },
            {
              trigger: 'blur',
              validator: validatePassword
            }
          ]
        },
        passwordType: 'password',
        loading: false,
        redirect: undefined,
        checked: false,
      }
    },
    watch: {
      $route: {
        handler: function(route) {
          this.redirect = route.query && route.query.redirect
        },
        immediate: true
      }
    },
    created() {},
    mounted() {
      this.loadAccountInfo()
    },
    destroyed() {},
    methods: {
      Decrypt(word) { //解密方法
        let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
        let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
        let decrypt = CryptoJS.AES.decrypt(srcs, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });
        let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
        return decryptedStr.toString();
      },
      Encrypt(word) { //加密方法
        let srcs = CryptoJS.enc.Utf8.parse(word);
        let encrypted = CryptoJS.AES.encrypt(srcs, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.ciphertext.toString().toUpperCase();
      },
      loadAccountInfo() {
        let self = this
        let accountInfo = Cookies.get('accountInfo')
        if (!accountInfo || accountInfo == 'undefined') {
          return false
        } else {
          let userName = ''
          let passWord = ''
          accountInfo = accountInfo.split('&') // 拿到加密后的密码
          // 解密
          self.loginForm.username = this.Decrypt(accountInfo[0])
          self.loginForm.password = this.Decrypt(accountInfo[1])
          self.checked = true
        }
      },
      showPwd() {
        if (this.passwordType === 'password') {
          this.passwordType = ''
        } else {
          this.passwordType = 'password'
        }
      },
      handleLogin() {
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            if (this.checked == true) {
              let newaccount = this.Encrypt(this.loginForm.username)
              let newPassord = this.Encrypt(this.loginForm.password)
              Cookies.set('accountInfo', newaccount + '&' + newPassord, 1440 * 5)
            } else { // 清空Cookie
              Cookies.set('accountInfo', undefined, -1)
            }
            this.loading = true
            this.$store.dispatch('LoginByUsername', this.loginForm).then(() => {
              this.loading = false
              Cookies.set('NoticeTime', new Date().getTime())
              // this.$router.push({ path: this.redirect || '/' })
              this.$router.push('/')
            }).catch(() => {
              this.loading = false
            })
          } else {
            //   console.log('error submit!!')
            return false
          }
        })
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss">
  /* 修复input 背景不协调 和光标变色 */
  /* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

  $bg:#283443;
  $light_gray:#eee;
  $cursor: #fff;

  @supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
    .login-container .el-input input {
      color: $cursor;

      &::first-line {
        color: $light_gray;
      }
    }
  }

  /* reset element-ui css */
  .login-container {
    .el-input {
      display: inline-block;
      height: 47px;
      width: 85%;

      input {
        background: transparent;
        position: relative;
        top: 2px;
        border: 0px;
        -webkit-appearance: none;
        border-radius: 0px;
        padding: 0 5px 0 15px;
        color: $light_gray;
        height: 47px;
        caret-color: $cursor;

        &:-webkit-autofill {
          -webkit-box-shadow: 0 0 0px 1000px $bg inset !important;
          -webkit-text-fill-color: $cursor !important;
        }
      }
    }

    .el-form-item {
      border: 1px solid rgba(255, 255, 255, 0.1);
      background: rgba(0, 0, 0, 0.1);
      border-radius: 5px;
      color: #454545;
    }
  }
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
  // $bg:#2d3a4b;
  $bg:transparent;
  $dark_gray:#889aa4;
  $light_gray:#eee;

  .login-container {
    min-height: 100%;
    width: 100%;
    background-color: $bg;
    overflow: hidden;

    .login-form {
      position: relative;
      width: 620px;
      max-width: 100%;
      padding: 160px 35px 0;
      margin: 0 auto;
      overflow: hidden;
    }

    .tips {
      font-size: 14px;
      color: #fff;
      margin-bottom: 10px;

      span {
        &:first-of-type {
          margin-right: 16px;
        }
      }
    }

    .svg-container {
      padding: 6px 5px 6px 15px;
      color: $dark_gray;
      vertical-align: middle;
      width: 30px;
      display: inline-block;
    }

    .title-container {
      position: relative;

      .title {
        font-size: 26px;
        color: $light_gray;
        margin: 0px auto 40px auto;
        text-align: center;
        font-weight: bold;
      }

      .set-language {
        color: #fff;
        position: absolute;
        top: 3px;
        font-size: 18px;
        right: 0px;
        cursor: pointer;
      }
    }

    .show-pwd {
      position: absolute;
      right: 10px;
      top: 7px;
      font-size: 16px;
      color: $dark_gray;
      cursor: pointer;
      user-select: none;
    }
  }
</style>
